import React, { useState, useEffect } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { getFallbackMakeLogoImage } from "../../../utils/carLogo/getFallbackMakeLogoImage";
import StorageIconSVG from "../../../../SharedComponents/assets/icons/svg/CancelIconSVG";
import { getRequestStateLabel } from "../../../utils/helpers/getRequestStateLabel";
import { getExpiresIn } from "../../../utils/helpers/getExpiresIn";
import api from "../../../../../api";

const defaultTextStyle = {
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  color: "black",
};

const AllRequestsTableRow = ({ carRequest, onSelect }) => {
  const [makeName, setMakeName] = useState(carRequest?.Make?.name || "");
  const generationName = carRequest?.Generation?.name || "N/A";

  useEffect(() => {
    if (!makeName && carRequest?.id_car_make) {
      const fetchMake = async () => {
        try {
          const response = await api.get(`/make/${carRequest.id_car_make}`);
          if (response.data?.name) {
            setMakeName(response.data.name);
          }
        } catch (error) {
          console.error("Greška pri učitavanju marke.", error);
        }
      };

      fetchMake();
    }
  }, [makeName, carRequest]);

  const logo = getFallbackMakeLogoImage(makeName);
  const stateLabel = getRequestStateLabel(carRequest?.state);
  const description = carRequest?.description || "N/A";
  const { text: expiresInText, hoursLeft } = getExpiresIn(carRequest?.createdAt);

  return (
    <TableRow hover onClick={onSelect} sx={{ cursor: "pointer" }}>
      <TableCell sx={defaultTextStyle}>
        <div style={styles.logoContainer}>
          <img src={logo} alt={makeName || "logo"} style={styles.logoImage} />
          <span>
            {makeName} {generationName}
          </span>
        </div>
      </TableCell>
      <TableCell sx={defaultTextStyle}>{carRequest?.vin || "N/A"}</TableCell>
      <TableCell
        sx={{
          ...defaultTextStyle,
          color: hoursLeft < 5 ? "red" : "black",
        }}
      >
        {expiresInText}
      </TableCell>
      <TableCell sx={defaultTextStyle}>
        <div style={styles.stateAndDescriptionContainer}>
          <div style={styles.getStateBadgeStyle(carRequest?.state)}>
            {stateLabel}
          </div>
          <span>{description}</span>
        </div>
      </TableCell>
      <TableCell>
        <StorageIconSVG style={styles.storageIcon} />
      </TableCell>
    </TableRow>
  );
};

export default AllRequestsTableRow;

const styles = {
  logoContainer: {
    display: "flex",
    alignItems: "center",
  },
  logoImage: {
    width: 80,
    height: 80,
    marginRight: 10,
  },
  stateAndDescriptionContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  getStateBadgeStyle: (state) => ({
    padding: "4px 12px",
    borderRadius: "999px",
    backgroundColor: state === 3 ? "red" : "green",
    color: "white",
    fontWeight: 400,
    fontSize: "12px",
    whiteSpace: "nowrap",
  }),
  storageIcon: {
    width: 24,
    height: 24,
  },
};
